import {RouteRecordRaw} from "vue-router";
import Index from "@/modules/main-menu/pages/Index.vue";
import Load from "@/modules/main-menu/pages/Load.vue";
import GameSlotsIndex from "@/modules/main-menu/pages/game-slots/Index.vue";
import GameSlotsCreate from "@/modules/main-menu/pages/game-slots/Create.vue";
import GameSlotsCreating from "@/modules/main-menu/pages/game-slots/Creating.vue";
import GameSlotsUpdate from "@/modules/main-menu/pages/game-slots/Update.vue";

export const routes: RouteRecordRaw[] = [
  {
    name: 'main-menu.load',
    path: '/',
    component: Load,
  },
  {
    name: 'main-menu.index',
    path: '/menu',
    component: Index,
  },
  {
    name: 'game-slots.index',
    path: '/game-slots',
    component: GameSlotsIndex,
  },
  {
    name: 'game-slots.create',
    path: '/game-slots/create',
    component: GameSlotsCreate,
  },
  {
    name: 'game-slots.creating',
    path: '/game-slots/creating',
    component: GameSlotsCreating,
  },
  {
    name: 'game-slots.update',
    path: '/game-slots/update',
    component: GameSlotsUpdate,
  },
];